'use client'
import { FC, ReactElement } from 'react'
import SlideOutMoreCategories, {
  ISlideOutMoreCategoriesProps
} from './slideouts/SlideOutMoreCategories'
import SlideOutCustomerOrderDetail, {
  SlideOutCustomerOrderDetailProps
} from '#/src/custom/controllers/slideouts/SlideOutCustomerOrderDetail'
import SlideOutMoreFilters, {
  ISlideOutMoreFiltersProps
} from '#/src/custom/controllers/slideouts/SlideOutMoreFilters'
import SlideOutMoreFilters1, {
  ISlideOutMoreFilters1
} from '#/src/custom/controllers/slideouts/SlideOutMoreFilters1'
import SlideOutMobileMenu, {
  SlideOutMobileMenuProps
} from '#/src/custom/controllers/slideouts/SlideOutMobileMenu'
import SlideOutCategoriesDesktop from './slideouts/SlideOutCategoriesDesktop'
import CustomSlideOutSearch from '#/src/custom/controllers/slideouts/CustomSlideOutSearch'
import SlideOutMoreFiltersSearch, {
  ISlideOutMoreFiltersSearch
} from './slideouts/SlideOutMoreFiltersSearch'

type SlideOutComponentDictionary = Record<SlideOutComponentType, ReactElement>
type SlideOutFooterDictionary = Record<SlideOutFooterType, ReactElement>

interface ISlideOutComponentProps {
  componentId: SlideOutComponentType | null
  extraArgs: unknown
}

interface ISlideOutFooterProps {
  footerId?: SlideOutFooterType | null
}

export const SlideOutComponent: FC<ISlideOutComponentProps> = ({ componentId, extraArgs }) => {
  if (!componentId) return null
  // components are added to this dictionary, and to access them, you will need to use useSlideOut hook to pass the
  // componentId to openSlideOut
  const dictionary: SlideOutComponentDictionary = {
    default: <div>DEV: no component selected</div>,

    mobileMenu: <SlideOutMobileMenu {...(extraArgs as SlideOutMobileMenuProps)} />,

    moreCategories: <SlideOutMoreCategories {...(extraArgs as ISlideOutMoreCategoriesProps)} />,

    moreFilters: <SlideOutMoreFilters {...(extraArgs as ISlideOutMoreFiltersProps)} />,

    moreFilters1: <SlideOutMoreFilters1 {...(extraArgs as ISlideOutMoreFilters1)} />,

    moreFiltersSearch: <SlideOutMoreFiltersSearch {...(extraArgs as ISlideOutMoreFiltersSearch)} />,

    customerOrderDetail: (
      <SlideOutCustomerOrderDetail {...(extraArgs as SlideOutCustomerOrderDetailProps)} />
    ),

    categories: <SlideOutCategoriesDesktop {...{ extraArgs }} />,

    searchDesktop: <CustomSlideOutSearch />
  }

  return dictionary[componentId] ?? dictionary.default
}

export const SlideOutFooter: FC<ISlideOutFooterProps> = ({ footerId }) => {
  if (!footerId) return null
  // components are added to this dictionary, and to access them, you will need to use useSlideOut hook to pass the
  // footerId to openSlideOut
  const dictionary: SlideOutFooterDictionary = {
    default: <div />
  }

  return (footerId ? dictionary[footerId] : null) ?? dictionary.default
}
